/* Rosterpress cart drawer behaviour (snippets/cart-drawer.liquid): grouped removal and the Shipping Protection /
   Rush Order toggles.
   Delegated click handling on #CartDrawer (survives every section re-render, no rebinding). Each action reads the
   fresh #rp-cart-data JSON, asks window.RPCartCore (rp-cart-core.js) for the cart change, sends ONE request
   (/cart/update.js, or /cart/add.js when turning protection on) with sections 'cart-drawer,cart-icon-bubble', then
   replaces #CartDrawer's contents and the header bubble in place without closing the drawer.
   Standard (non-bundle) lines keep Dawn's quantity-input / cart-remove-button (cart.js). */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var ERROR_MSG = "Sorry, we couldn't update your cart. Please try again.";
  var busy = false;

  function root() { return document.getElementById('CartDrawer'); }

  function readData() {
    var el = document.getElementById('rp-cart-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function url(name, fallback) {
    var r = window.routes || {};
    return (r[name] || fallback) + '.js';
  }

  function setBusy(on) {
    var r = root();
    if (!r) return;
    var inner = r.querySelector('.drawer__inner');
    if (inner) {
      inner.classList.toggle('is-busy', on);
      inner.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    r.querySelectorAll('button:not(.drawer__close)').forEach(function (b) {
      if (on) {
        if (b.disabled) b.setAttribute('data-rp-was-disabled', '');
        b.disabled = true;
      } else if (b.hasAttribute('data-rp-was-disabled')) {
        b.removeAttribute('data-rp-was-disabled');
      } else {
        b.disabled = false;
      }
    });
  }

  function showError(msg) {
    var r = root();
    var el = r && r.querySelector('[data-rp-error]');
    if (!el) return;
    el.textContent = msg || ERROR_MSG;
    el.hidden = false;
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* Same effect as Dawn's cart-drawer.renderContents (replace #CartDrawer inner + bubble) but without re-opening. */
  function attr(name, value) {
    return '[' + name + '="' + (window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&')) + '"]';
  }

  /* focusWanted: selectors tried in order after the re-render; falls back to the drawer's close button. */
  function render(sections, focusWanted) {
    var drawer = document.querySelector('cart-drawer');
    var target = root();
    var src = sections && sections['cart-drawer'] && parse(sections['cart-drawer']).querySelector('#CartDrawer');
    if (!drawer || !target || !src) throw new Error('render');
    target.innerHTML = src.innerHTML;

    var bubble = document.getElementById('cart-icon-bubble');
    var bubbleSrc = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
    if (bubble && bubbleSrc) bubble.innerHTML = bubbleSrc.innerHTML;

    var empty = !!target.querySelector('.drawer__inner-empty');
    drawer.classList.toggle('is-empty', empty);
    var overlay = target.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));

    if (drawer.classList.contains('active')) {
      var focusEl = null;
      (focusWanted || []).some(function (sel) { focusEl = target.querySelector(sel); return !!focusEl; });
      focusEl = focusEl || target.querySelector('.drawer__close') || target.querySelector('.drawer__inner');
      var container = empty ? target.querySelector('.drawer__inner-empty') : target;
      if (typeof window.trapFocus === 'function' && container) window.trapFocus(container, focusEl);
      else if (focusEl) focusEl.focus();
    }
  }

  function post(endpoint, body) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || json.status) throw new Error(json.description || json.message || ERROR_MSG);
        return json;
      });
    });
  }

  function run(plan, focusWanted) {
    if (busy || !plan) return;
    var hasUpdates = plan.updates && Object.keys(plan.updates).length;
    if (!hasUpdates && !(plan.add && plan.add.length)) return;
    busy = true;
    setBusy(true);
    var req = plan.add
      ? post(url('cart_add_url', '/cart/add'), { items: plan.add, sections: SECTIONS })
      : post(url('cart_update_url', '/cart/update'), { updates: plan.updates, sections: SECTIONS });
    req
      .then(function (json) { render(json.sections, focusWanted); })
      .catch(function () {
        setBusy(false);
        showError(ERROR_MSG);
      })
      .then(function () { busy = false; });
  }

  /* Upsell card: add the size picked in its <select> (or the card's default variant), then re-render in place. */
  document.addEventListener('click', function (event) {
    var r = root();
    var add = event.target.closest && event.target.closest('[data-rp-upsell-add]');
    if (!r || !add || !r.contains(add)) return;
    event.preventDefault();
    var card = add.closest('.rp-cd-up__card');
    var sel = card && card.querySelector('[data-rp-upsell-size]');
    var id = Number((sel && sel.value) || add.getAttribute('data-rp-upsell-add'));
    if (!id) { showError(ERROR_MSG); return; }
    run({ add: [{ id: id, quantity: 1 }] }, ['.rp-cd-up__add']);
  });

  document.addEventListener('click', function (event) {
    var r = root();
    var btn = event.target.closest && event.target.closest('[data-rp-remove-shirt],[data-rp-remove-bundle],[data-rp-protect],[data-rp-rush]');
    if (!r || !btn || !r.contains(btn)) return;
    event.preventDefault();
    var Core = window.RPCartCore;
    var data = readData();
    if (!Core || !data || !data.items) { showError(ERROR_MSG); return; }

    var plan = null;
    var focusWanted = [];
    if (btn.hasAttribute('data-rp-remove-shirt')) {
      plan = Core.removeShirt(data.items, btn.getAttribute('data-rp-remove-shirt'), data.fees);
      // next row's remove button, else this bundle's "Remove all", else (fallback) the close button
      var row = btn.closest('li');
      for (var nx = row && row.nextElementSibling; nx; nx = nx.nextElementSibling) {
        var nb = nx.querySelector('[data-rp-remove-shirt]');
        if (nb) { focusWanted.push(attr('data-rp-remove-shirt', nb.getAttribute('data-rp-remove-shirt'))); break; }
      }
      var card = btn.closest('[data-rp-bundle]');
      if (card) focusWanted.push(attr('data-rp-remove-bundle', card.getAttribute('data-rp-bundle')));
    } else if (btn.hasAttribute('data-rp-remove-bundle')) {
      plan = Core.removeBundle(data.items, btn.getAttribute('data-rp-remove-bundle'), data.fees);
    } else if (btn.hasAttribute('data-rp-rush')) {
      var rushOn = btn.getAttribute('aria-checked') !== 'true';
      if (rushOn && !data.rushVariantId) { showError(ERROR_MSG); return; }
      plan = Core.toggleRush(data.items, rushOn, data.fees, data.rushVariantId);
      focusWanted.push('[data-rp-rush]');
    } else {
      var on = btn.getAttribute('aria-checked') !== 'true';
      if (on && !data.protVariantId) { showError(ERROR_MSG); return; }
      plan = Core.toggleProtection(data.items, on, data.fees, data.protVariantId);
      focusWanted.push('[data-rp-protect]');
    }
    run(plan, focusWanted);
  });
})();
